// loadingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    isFilterLoading: false,
    isTabLoading: false
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setFilterLoading: (state, action) => {
            state.isFilterLoading = action.payload;
        },
        setTabLoading: (state, action) => {
            state.isTabLoading = action.payload;
        }
    }
});

export const { setLoading, setFilterLoading, setTabLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
